import { startCase } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

import { snFadeInDown } from '@lib/common/animations';
import { TranslationService } from '@lib/translation';
import { t } from '@lib/translation/helpers';

import { ISnActivationError } from '../../containers/activate';

@Component({
  templateUrl: './activate.view.html',
  styleUrls: ['./activate.view.scss'],
  animations: [snFadeInDown],
})
export class ActivateView implements OnInit, OnDestroy {
  public readonly uid: string;
  public readonly token: string;
  public serverErrors;

  public activationIsFail = false;
  public translationsLoaded = false;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _router: Router,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _snackbar: MatSnackBar,
    private readonly _translationService: TranslationService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
  ) {
    this.uid = this._activatedRoute.snapshot.params.uid;
    this.token = this._activatedRoute.snapshot.params.token;
  }

  public ngOnInit(): void {
    this._translationService.translationReady$().pipe(
      takeUntil(this._destroy$)
    ).subscribe(() => {
      this.translationsLoaded = true;
      this._changeDetectorRef.detectChanges();
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onError(error: ISnActivationError): void {
    if (!error) {
      this.activationIsFail = false;
    } else {
      if (error.email) {
        this._snackbar.open(t('auth.activate.errors.invalidLink'));
        this._router.navigate(['/auth', 'sign-in']);
      } else {
        this.activationIsFail = true;
      }
    }
  }

  public onConfirm(): void {
    this._snackbar.open(t('auth.activate.success.accountActivated'), null, {
      panelClass: 'user-activated__snackbar',
    });
    this._router.navigate(['/auth', 'sign-in']);
  }

  public onServerError(errors: any[]): void {
    this.serverErrors = errors;
  }

  public isArray(value: any): boolean {
    return Array.isArray(value);
  }

  public toStartCase(text: string): string {
    return startCase(text);
  }
}
